/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

const DEV ="development"
const PROD = "production"
const STAG = "staging"

let currentEnv = `${NODE_ENV}`

var poolDataDev = {
    UserPoolId: 'ap-northeast-1_ttmktfzQe',
    ClientId: '5akajkbnp63u0062r69arjeg3t',
};

var poolDataStaging = {
    UserPoolId: 'ap-northeast-1_MJ4AFYN07',
    ClientId: '300hch38sdte05nf0n6mqcm92n',
};

var poolDataProd = {
    UserPoolId: 'ap-northeast-1_D6U2gs7rJ',
    ClientId: '2a9s4kikv1qvdus9okj5qsno5q',
};

export function getCognitoCredential(env) {
    if (currentEnv == STAG) {
        return poolDataStaging
    } else if (currentEnv == PROD) {
        return poolDataProd
    } else {
        return poolDataDev
    }
}

export function getPegadaBaseUrl(env) {
    if (currentEnv == STAG) {
        return "https://api.rulerless-stg.com/api"
    } else if (currentEnv == PROD) {
        return "https://api.rulerless-web.com/api"
    } else {
        return "https://api.iot-pegada.com/api"
    }
}

export function getRulerlessBaseUrl(env) {
    if (currentEnv == STAG) {
        return "https://rulerless.rulerless-stg.com/api"
    } else if (currentEnv == PROD) {
        return "https://rulerless.rulerless-web.com/api"
    } else {
        return "https://rulerless.iot-pegada.com/api"
    }
}

export function getLoginUrl(env) {
    if (currentEnv == STAG) {
        return "https://static.rulerless-stg.com/auth/login"
    } else if (currentEnv == PROD) {
        return "https://static.rulerless-web.com/auth/login"
    } else {
        return "https://static.iot-pegada.com/auth/login"
    }
}

export function getHomePageUrl() {
    if (location.host.startsWith("localhost")) return "http://localhost"
    if (currentEnv == STAG) {
        return "https://static.rulerless-stg.com"
    } else if (currentEnv == PROD) {
        return "https://static.rulerless-web.com"
    } else {
        return "https://static.iot-pegada.com"
    }
}

export function getAPIKey() {
    if (currentEnv == STAG) {
        return "1FMjCQRVIo82tC3I7Wu922FB2YXpTR0V5Sa7kcUw"
    } else if (currentEnv == PROD) {
        return "1FMjCQRVIo82tC3I7Wu922FB2YXpTR0V5Sa7kcUw"
    } else {
        return "1FMjCQRVIo82tC3I7Wu922FB2YXpTR0V5Sa7kcUw"
    }
}
